import React from 'react'

const CurrentPlayer = props => {
  return <div className="current-player">Current Player is {props.player}</div>
}

export default CurrentPlayer



// WEBPACK FOOTER //
// ./src/components/CurrentPlayer.js